"use client";

import { useEffect, useRef, useState } from "react";
import Core from "smooothy";

export default function ModulosCarousel({ items }) {
  const carouselRef = useRef(null);
  const sliderRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const total = items.length;
  const current = ((activeIndex % total) + total) % total + 1;

  useEffect(() => {
    const el = carouselRef.current;
    if (!el) return;

    const slider = new Core(el, {

      snap: true,
      infinite: true,
      virtualScroll: {
        mouseMultiplier: 0,
        touchMultiplier: 3,
        firefoxMultiplier: 0,
      },
      onSlideChange: (currentSlide) => {
        setActiveIndex(currentSlide);
      },
    });

    sliderRef.current = slider;

    let rafId;
    let lastIndex = -1;
    const animate = () => {
      slider.update();
      const idx = slider.currentSlide ?? 0;
      if (idx !== lastIndex) {
        lastIndex = idx;
        setActiveIndex(idx);
      }
      rafId = requestAnimationFrame(animate);
    };
    animate();

    return () => {
      cancelAnimationFrame(rafId);
      slider.destroy();
    };
  }, []);

  return (
    <>
    <div id="modulos2carousel" ref={carouselRef}>
      {items.map((moduleItem, index) => {
        const isActive = index === activeIndex;
        return (
          <div
            key={`modulo-m-${moduleItem.label}`}
            className="modulo-carousel-item"
          >
            <div className={`modulo${isActive ? " is-active" : ""}`}>
              <img
                src={moduleItem.iconSrc}
                alt={moduleItem.alt}
                width="120"
                height="120"
                loading="lazy"
                decoding="async"
              />
              <div className="modulo-active-desc">
                <span className="modulo-active-title">
                  {moduleItem.label}
                </span>
                {moduleItem.description}
              </div>
            </div>
          </div>
        );
      })}
    </div>
    <div id="modulos2-counter">
      <span className="modulos2-counter-arrow" onClick={() => sliderRef.current?.goToPrev()}>&#8592;</span>
      <span className="modulos2-counter-label">{current}&nbsp;/&nbsp;{total}</span>
      <span className="modulos2-counter-arrow" onClick={() => sliderRef.current?.goToNext()}>&#8594;</span>
    </div>
    </>
  );
}
